import { ReactElement } from 'react';

import { Grid } from '@mui/material';

import FishHunter from './components/FishHunter';
import LiveCasino from './components/LiveCasino';
import SlotGames from './components/SlotGames';
import Sportsbook from './components/Sportsbook';
import { Product as ProductType } from './types';

import Section from '../../components/Section';

const products: ProductType[] = [
  {
    id: 'sportsbook',
    component: <Sportsbook />
  },
  {
    id: 'liveCasino',
    component: <LiveCasino />
  },
  {
    id: 'slotGames',
    component: <SlotGames />
  },
  {
    id: 'fishHunter',
    component: <FishHunter />
  }
];

export default function Products(): ReactElement {
  return (
    <Section title='Products' id='products'>
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='stretch'
        spacing={2}>
        {products.map((product) => (
          <Grid id={product.id} key={product.id} item xs={12} sm={6} md={3}>
            {product.component}
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}
